import createIcon from '../../createIcon';

/**
 * @component @name SportsMartialArts
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOCAyLjVMMTEuNiA5LjJMMTAuMzkgOC4xNkwxMy45OSA2LjA4TDkuNDEgMS41TDggMi45MUwxMC43NCA1LjY1TDUgOC45NkwzLjgxIDEzLjI1TDYuMjcgMTcuNUw4IDE2LjVMNS45NyAxMi45OEw2LjMyIDExLjY4TDkuNSAxMy41TDEwIDIyLjVIMTJMMTIuNSAxMi41TDIxIDMuOUwxOS44IDIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01IDcuNUM2LjEwNDU3IDcuNSA3IDYuNjA0NTcgNyA1LjVDNyA0LjM5NTQzIDYuMTA0NTcgMy41IDUgMy41QzMuODk1NDMgMy41IDMgNC4zOTU0MyAzIDUuNUMzIDYuNjA0NTcgMy44OTU0MyA3LjUgNSA3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsMartialArts = createIcon('SportsMartialArts', [
  [
    'path',
    {
      d: 'M19.8 2.5L11.6 9.2L10.39 8.16L13.99 6.08L9.41 1.5L8 2.91L10.74 5.65L5 8.96L3.81 13.25L6.27 17.5L8 16.5L5.97 12.98L6.32 11.68L9.5 13.5L10 22.5H12L12.5 12.5L21 3.9L19.8 2.5Z',
      key: 'rw8sj4',
    },
  ],
  [
    'path',
    {
      d: 'M5 7.5C6.10457 7.5 7 6.60457 7 5.5C7 4.39543 6.10457 3.5 5 3.5C3.89543 3.5 3 4.39543 3 5.5C3 6.60457 3.89543 7.5 5 7.5Z',
      key: 'yx15e2',
    },
  ],
]);

export default SportsMartialArts;
